import { AppDispatch } from "@/store";
import { IStandSettings } from "@/models/StandSettings";
import { serverSocket } from "@/store/reducers/serverConnection/asyncActionCreators";
import {
  setEditSettingsError,
  setEditSettingsLoading,
  setStandSettings,
} from "@/store/reducers/settings/settingsSlice";

export const listenSettings = () => (dispatch: AppDispatch) => {
  try {
    serverSocket.off("SERVER:read_sp_settings");

    serverSocket.on(
      "SERVER:read_sp_settings",
      ({ data: settings }: { data: IStandSettings }) => {
        dispatch(setEditSettingsLoading(false));
        dispatch(setStandSettings(settings));
      }
    );
  } catch (e: any) {}
};

export const editSettings =
  (settings: IStandSettings) => (dispatch: AppDispatch) => {
    try {
      if (serverSocket.connected) {
        dispatch(setEditSettingsLoading(true));
        dispatch(setEditSettingsError(""));
        serverSocket.volatile.emit("SERVER:edit_sp_settings", {
          data: settings,
        });
      }
    } catch (e: any) {}
  };
